import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';   // initialise i18next before any component renders
import App from './App';

// Dates and times in English follow the PRD figures (British style: "Tuesday 19 May 2026", "14:32").
// Screens pass the i18next language ("en" / "fr"); "en" alone would format the US way.
['toLocaleDateString', 'toLocaleTimeString', 'toLocaleString'].forEach(method => {
  const original = Date.prototype[method];
  Date.prototype[method] = function localized(locale, options) {
    return original.call(this, locale === 'en' ? 'en-GB' : locale, options);
  };
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
